import * as yup from 'yup';

export const MAX_MESSAGE_LENGTH = 140;

export const noticeBannerSchema = (isEdit = false): yup.AnyObjectSchema =>
  yup
    .object({
      message: yup
        .string()
        .transform((v) => (typeof v === 'string' ? v.trim() : v))
        .max(MAX_MESSAGE_LENGTH, `Message should contain up to ${MAX_MESSAGE_LENGTH} characters`)
        .required('Message is a required field'),
      start_datetime: yup
        .date()
        .nullable()
        .transform((v, orig) => (orig === '' ? null : v))
        .when([], {
          is: () => !isEdit,
          then: (schema) =>
            schema.min(new Date(Date.now() + 5 * 60 * 1000), 'Start date must be at least 5 minutes from now'),
        })
        .notRequired(),
      end_datetime: yup
        .date()
        .nullable()
        .transform((v, orig) => (orig === '' ? null : v))
        .when('start_datetime', {
          is: (v: unknown) => !!v,
          then: (schema) => schema.min(yup.ref('start_datetime'), 'End date must be later than start date'),
        })
        .notRequired(),
    })
    .required();
